import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ModalComponent } from 'ng2-bs3-modal/ng2-bs3-modal';
import { Repository } from '../../../services/repository';

const swal = require('sweetalert');

@Component({
  selector: 'app-chuyentrangthai-action',
  templateUrl: './chuyentrangthai-action.component.html',
  styleUrls: ['./chuyentrangthai-action.component.scss']
})
export class ChuyenTrangThaiActionComponent implements OnInit {
  @Input() reportId: string;
  @Input() phanHeId: string;
  @Input() trangThai: number;
  @Output() changed = new EventEmitter<void>();

  @ViewChild('modal', { static: false }) modal: ModalComponent;

  isQuantri = false;
  dsTrangThai: any[] = [];
  selectedTrangThai: number = null;

  constructor(private repo: Repository) { }

  ngOnInit(): void {
    this.repo.getRequest('api/bc02/is_quantri').subscribe(
      data => {
        this.isQuantri = data === 1 || data === '1' || data === true;
      },
      () => {
        this.isQuantri = false;
      }
    );
  }

  get showAction(): boolean {
    return this.isQuantri && Number(this.trangThai) === 5;
  }

  openModal(): void {
    if (!this.showAction) {
      return;
    }

    this.repo.getRequest('api/baselayout/TrangThai_Read').subscribe(
      data => {
        this.dsTrangThai = (data || []).filter((item: any) => item.Id !== 5);
        this.selectedTrangThai = this.dsTrangThai.length > 0 ? this.dsTrangThai[0].Id : null;
        this.modal.open();
      },
      error => {
        swal('Cảnh báo!', error, 'warning');
      }
    );
  }

  save(): void {
    if (this.selectedTrangThai === null || this.selectedTrangThai === undefined) {
      swal('Cảnh báo!', 'Vui lòng chọn trạng thái mới!', 'warning');
      return;
    }

    const tenTrangThai = this.dsTrangThai.find(x => x.Id === this.selectedTrangThai);
    swal({
      title: 'Chuyển trạng thái báo cáo?',
      text: 'Chuyển từ "Hoàn thành báo cáo" sang "' + (tenTrangThai ? tenTrangThai.Ten : '') + '"?',
      icon: 'warning',
      buttons: {
        cancel: {
          text: 'Hủy bỏ',
          value: false,
          visible: true,
        },
        confirm: {
          text: 'Đồng ý',
          value: true,
          visible: true,
          className: 'bg-danger',
          closeModal: true
        }
      }
    }).then(confirmed => {
      if (!confirmed) {
        return;
      }

      $('#loading').show();
      this.repo.getRequest('api/bc02/chuyentrangthai/' + this.reportId + '/' + this.selectedTrangThai + '/' + this.phanHeId).subscribe(
        data => {
          $('#loading').hide();
          if (data === 'OK' || data === 1) {
           // swal('Thông báo!', 'Đã chuyển trạng thái báo cáo thành công!', 'success');
            this.modal.dismiss();
            this.changed.emit();
          } else {
            swal('Cảnh báo!', data, 'warning');
          }
        },
        error => {
          $('#loading').hide();
          swal('Cảnh báo!', error, 'warning');
        }
      );
    });
  }
}
